import api from './api';

export interface School {
  id: string;
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  enabled?: boolean;
}

export const schoolService = {

  createSchool: async (school: Omit<School, 'id'>): Promise<School> => {
    const response = await api.post<School>('/schools', school);
    return response.data;
  },

  updateSchool: async (id: string, school: Partial<School>): Promise<School> => {
    const response = await api.put<School>(`/schools/${id}`, school);
    return response.data;
  },

  getSchools: async (): Promise<School[]> => {
    const response = await api.get<School[]>('/schools');
    return response.data;
  }
};

